import { useEffect, useMemo, useRef, useState } from "react";
import { MeetingProvider, MeetingConsumer, useMeeting, useParticipant,useMediaDevice, Constant,createCameraVideoTrack, createMicrophoneAudioTrack,getNetworkStats } from "@videosdk.live/react-sdk";
import { authToken, createMeeting } from "../page_components/videocall/API";
import ReactPlayer from "react-player";
import useMediaStream from "../hooks/videosdkhooks/useMediaStream";
import useIsMobile from "../hooks/videosdkhooks/useIsMobile";
import MicPermissionDenied from "../components/MicPermissionDenied";
import CameraPermissionDenied from "../components/CameraPermissionDenied";

import RefreshCheck from "../components/NetworkStats/RefreshCheck";
import DownloadIcon from "../components/NetworkStats/DownloadIcon";
import UploadIcon from "../components/NetworkStats/UploadIcon";
import RefreshIcon from "../components/NetworkStats/RefreshIcon";
import WifiOff from "../components/NetworkStats/WifiOff";


function JoinScreen({ getMeetingAndToken }) {

    const [selectedMic, setSelectedMic] = useState({ id: null, label: null });
    const [selectedWebcam, setSelectedWebcam] = useState({ id: null, label: null });
    const [selectedSpeaker, setSelectedSpeaker] = useState({ id: null, label: null });
    const [isCameraPermissionAllowed, setIsCameraPermissionAllowed] = useState(null);
    const [isMicrophonePermissionAllowed, setIsMicrophonePermissionAllowed] = useState(null);
    const [raisedHandsParticipants, setRaisedHandsParticipants] = useState([]);
    const [sideBarMode, setSideBarMode] = useState(null);
    const [pipMode, setPipMode] = useState(false);

    const [audioTrack, setAudioTrack] = useState(null);
    const [videoTrack, setVideoTrack] = useState(null);
    const [dlgMuted, setDlgMuted] = useState(false);
    const [dlgDevices, setDlgDevices] = useState(false);
    const [didDeviceChange, setDidDeviceChange] = useState(false);

    const videoPlayerRef = useRef();
    const videoTrackRef = useRef();
    const audioTrackRef = useRef();
    const audioAnalyserIntervalRef = useRef();
    const permissonAvaialble = useRef();
    const webcamRef = useRef();
    const micRef = useRef();


    const [micOn, setMicOn] = useState(false);
    const [webcamOn, setWebcamOn] = useState(false);

    const [customAudioStream, setCustomAudioStream] = useState(null);
    const [customVideoStream, setCustomVideoStream] = useState(null)


    const [error, setError] = useState("no-error-loading")
    const [uploadSpeed, setUploadSpeed] = useState(null)
    const [downloadSpeed, setDownloadSpeed] = useState(null)

    useEffect(() => { getNetworkStatistics(); }, [])

    const getNetworkStatistics = async () => {
        setError("no-error-loading");
        try {
        const options = { timeoutDuration: 45000 }; // Set a custom timeout of 45 seconds
        const networkStats = await getNetworkStats(options);
        if (networkStats) {
            setError("no-error");
        }
        setDownloadSpeed(networkStats["downloadSpeed"]);
        setUploadSpeed(networkStats["uploadSpeed"])
        } catch (ex) {
        if (ex === "Not able to get NetworkStats due to no Network") {
            setError("no-wifi")
        }
        if (ex === "Not able to get NetworkStats due to timeout") {
            setError("timeout")
        }
        console.log("Error in networkStats: ", ex);
        }
    }
    
    const handleOnClick = () => {
        getNetworkStatistics()
    }

function onDeviceChanged() {
    setDidDeviceChange(true);
    getCameraDevices();
    getAudioDevices();
  }


  const getCameraDevices = async () => {
    try {
    //   if (permissonAvaialble.current?.isCameraPermissionAllowed) {
        let webcams = await getCameras();
        setSelectedWebcam({
          id: webcams[0]?.deviceId,
          label: webcams[0]?.label,
        });
        setDevices((devices) => {
          return { ...devices, webcams };
        });
    //   }
    } catch (err) {
      console.log("Error in getting camera devices", err);
    }
  };

  async function startMuteListener() {
    const currentAudioTrack = audioTrackRef.current;
    if (currentAudioTrack) {
      if (currentAudioTrack.muted) {
        setDlgMuted(true);
      }
      currentAudioTrack.addEventListener("mute", (ev) => {
        setDlgMuted(true);
      });
    }
  }

  const getAudioDevices = async () => {
    try {
      //if (permissonAvaialble.current?.isMicrophonePermissionAllowed) {
        let mics = await getMicrophones();
        console.log(mics)
        let speakers = await getPlaybackDevices();
        const hasMic = mics.length > 0;
        if (hasMic) {
          startMuteListener();
        }
        await setSelectedSpeaker({
          id: speakers[0]?.deviceId,
          label: speakers[0]?.label,
        });
        await setSelectedMic({ id: mics[0]?.deviceId, label: mics[0]?.label });
        setDevices((devices) => {
          return { ...devices, mics, speakers };
        });
     // }
    } catch (err) {
      console.log("Error in getting audio devices", err);
    }
  };


  useEffect(() => {
    getAudioDevices()
  }, [])


useEffect(() => {
    getCameraDevices();
  }, []);


    const getDefaultMediaTracks = async ({ mic, webcam }) => {

    if (mic) {
      const stream = await getAudioTrack({
        micId: selectedMic.id,
      });
      setCustomAudioStream(stream);
      const audioTracks = stream?.getAudioTracks();
      const audioTrack = audioTracks.length ? audioTracks[0] : null;
      setAudioTrack(audioTrack);
    }

    if (webcam) {
      const stream = await getVideoTrack({
        webcamId: selectedWebcam.id,
      });
      setCustomVideoStream(stream);
      const videoTracks = stream?.getVideoTracks();
      const videoTrack = videoTracks?.length ? videoTracks[0] : null;
      setVideoTrack(videoTrack);
    }
  };


   const _toggleWebcam = () => {
    const videoTrack = videoTrackRef.current;

    if (webcamOn) {
      if (videoTrack) {
        videoTrack.stop();
        setVideoTrack(null);
        setCustomVideoStream(null);
        setWebcamOn(false);
      }
    } else {
      getDefaultMediaTracks({ mic: false, webcam: true });
      setWebcamOn(true);
    }
  };


    useEffect(() => {
    if (webcamOn) {

        console.log("asdasd",webcamOn);

      // Close the existing video track if there's a new one
      if (videoTrackRef.current && videoTrackRef.current !== videoTrack) {
        videoTrackRef.current.stop(); // Stop the existing video track
      }

      videoTrackRef.current = videoTrack;

      var isPlaying =
        videoPlayerRef.current.currentTime > 0 &&
        !videoPlayerRef.current.paused &&
        !videoPlayerRef.current.ended &&
        videoPlayerRef.current.readyState >
        videoPlayerRef.current.HAVE_CURRENT_DATA;

      if (videoTrack) {
        const videoSrcObject = new MediaStream([videoTrack]);

        if (videoPlayerRef.current) {
          videoPlayerRef.current.srcObject = videoSrcObject;
          if (videoPlayerRef.current.pause && !isPlaying) {
            videoPlayerRef.current
              .play()
              .catch((error) => console.log("error", error));
          }
        }
      } else {
        if (videoPlayerRef.current) {
          videoPlayerRef.current.srcObject = null;
        }
      }
    }
  }, [webcamOn, videoTrack]);




const changeWebcam = async (deviceId) => {
    if (webcamOn) {
      const currentvideoTrack = videoTrackRef.current;
      if (currentvideoTrack) {
        currentvideoTrack.stop();
      }

      const stream = await getVideoTrack({
        webcamId: deviceId,
      });
      setCustomVideoStream(stream);
      const videoTracks = stream?.getVideoTracks();
      const videoTrack = videoTracks?.length ? videoTracks[0] : null;
      setVideoTrack(videoTrack);
    }
  };




const [{ webcams, mics, speakers }, setDevices] = useState({
    webcams: [],
    mics: [],
    speakers: [],
  });
  const { getVideoTrack, getAudioTrack } = useMediaStream();
  const {
    checkPermissions,
    getCameras,
    getMicrophones,
    requestPermission,
    getPlaybackDevices,
  } = useMediaDevice({ onDeviceChanged });


  const [meetingId, setMeetingId] = useState(null);
  const onClick = async () => {
    await getMeetingAndToken(meetingId);
  };
  return (
    <div>
  <div className="absolute xl:bottom-6 bottom-4 left-0 right-0">
                        <div className="container grid grid-flow-col space-x-4 items-center justify-center md:-m-2">
                          
                            <button className="btn btn-info" type="button"
                              onClick={_toggleWebcam}
                              mic={false}
                            >Toggle Camera</button>
                         

                          {isCameraPermissionAllowed ? (
                            <button type="button"
                              onClick={_toggleWebcam}
                              mic={false}
                            />
                          ) : (
                            <CameraPermissionDenied />
                          )}
                        </div>
                      </div>


 <div className="flex flex-row auto-cols-max border border-[#3F4346] divide-x divide-[#3F4346] rounded-md bg-black opacity-80 h-9 ">
        
        {error === "no-error-loading" &&
          <div className="group inline-flex items-center gap-3 text-xs text-customGray-250 ml-3 ">
            Checking network speeds
            <RefreshCheck />
          </div>
        }
        

        {error === "no-error" &&
          <>
            <div className="group  inline-flex items-center gap-2 text-xs text-customGray-250 basis-1/2 w-32">
              <DownloadIcon />
              {downloadSpeed} MBPS
            </div>
            <div className="group inline-flex items-center gap-2 text-xs text-customGray-250 basis-1/2 w-32">
              <UploadIcon />
              {uploadSpeed} MBPS
            </div>
            <div className="basis-1/6 flex items-center justify-center" onClick={handleOnClick}>
              <RefreshIcon />
            </div>
          </>
        }

        {error === "no-wifi" &&
          <>
            <div className="group inline-flex items-center gap-3 text-xs text-red-250 p-2 ">
              <WifiOff />
              You're offline! Check your connection
            </div>
            <div className=" flex items-center justify-center p-2" onClick={handleOnClick}>
              <RefreshIcon />
            </div>
          </>
        }

        {error === "timeout" &&
          <>
            <div className="group inline-flex items-center gap-3 text-xs text-red-250 p-2 ">
              Something went wrong! Couldn't load data
            </div>
            <div className=" flex items-center justify-center p-2" onClick={handleOnClick}>
              <RefreshIcon />
            </div>
          </>
        }

      </div>


         <div className="w-full relative" style={{ height: "55vh" }}>
                      <video
                        autoPlay
                        playsInline
                        muted
                        ref={videoPlayerRef}
                        controls={false}
                        style={{
                          backgroundColor: "#1c1c1c",
                        }}
                        className={
                          "rounded-[10px] h-full w-full object-cover flex items-center justify-center flip"
                        }
                      />
                    
                          {!useIsMobile ? (
                                <>
                                <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
                                    {!webcamOn ? (
                                    <p className="text-xl xl:text-lg 2xl:text-xl text-white">
                                        The camera is off
                                    </p>
                                    ) : null}
                                </div>
                                </>
                            ) : null}



                    
                    </div>








          <select
            onChange={(e) => {
                const deviceId = e.target.value;
                const selected = webcams.find(w => w.deviceId === deviceId);
                
                setSelectedWebcam({
                    id: selected.deviceId,
                    label: selected.label,
                });

                changeWebcam(deviceId);
            }}
            value={selectedWebcam?.id || ''}
            className="text-white bg-black p-2 rounded">
            {webcams
                .filter((item) => item.kind === 'videoinput')
                .map((item, index) => (
                <option key={`webcams_${index}`} value={item.deviceId}>
                    {item.label || `Webcam ${index + 1}`}
                </option>
                ))}
            </select>


           <select >
              {mics.map(
                  (item, index) => {
                      return (
                          item?.kind === "audioinput" && (
                              <option key={`mics_${index}`} value={item.value}>{item.label}</option>
                          )
                      );
                  }
              )}
          </select>

          <select >
              {speakers.map(
                  (item, index) => {
                      return (
                          item?.kind === "audiooutput" && (
                              <option key={`speakers_${index}`} value={item.value}>{item.label}</option>
                          )
                      );
                  }
              )}
          </select>


          

      <input
        type="text"
        placeholder="Enter Meeting Id"
        onChange={(e) => {
          setMeetingId(e.target.value);
        }}
      />
      <button onClick={onClick}>Join</button>
      {" or "}
      <button onClick={onClick}>Create Meeting</button>
    </div>
  );
}
function ParticipantView(props) {
  const micRef = useRef(null);
  const { webcamStream, micStream, webcamOn, micOn, isLocal, displayName } =
    useParticipant(props.participantId);

  const videoStream = useMemo(() => {
    if (webcamOn && webcamStream) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      return mediaStream;
    }
  }, [webcamStream, webcamOn]);

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);

        micRef.current.srcObject = mediaStream;
        micRef.current
          .play()
          .catch((error) =>
            console.error("videoElem.current.play() failed", error)
          );
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn]);

  return (
    <div>
      <p>
        Participant: {displayName} | Webcam: {webcamOn ? "ON" : "OFF"} | Mic:{" "}
        {micOn ? "ON" : "OFF"}
      </p>
      <audio ref={micRef} autoPlay playsInline muted={isLocal} />
      {webcamOn && (
        <ReactPlayer
          //
          playsinline // extremely crucial prop
          pip={false}
          light={false}
          controls={false}
          muted={true}
          playing={true}
          //
          url={videoStream}
          //
          height={"300px"}
          width={"300px"}
          onError={(err) => {
            console.log(err, "participant video error");
          }}
        />
      )}
    </div>
  );
}

function Controls() {
  const { leave, toggleMic, toggleWebcam } = useMeeting();
  return (
    <div>
      <button onClick={() => leave()}>Leave</button>
      <button onClick={() => toggleMic()}>toggleMic</button>
      <button onClick={() => toggleWebcam()}>toggleWebcam</button>
    </div>
  );
}

function MeetingView(props) {
  const [joined, setJoined] = useState(null);
  //Get the method which will be used to join the meeting.
  //We will also get the participants list to display all participants
  const { join, participants } = useMeeting({
    //callback for when meeting is joined successfully
    onMeetingJoined: () => {
      setJoined("JOINED");
    },
    //callback for when meeting is left
    onMeetingLeft: () => {
      props.onMeetingLeave();
    },
  });
  const joinMeeting = () => {
    setJoined("JOINING");
    join();
  };

  return (
    <div className="container">
      <h3>Meeting Id: {props.meetingId}</h3>
      {joined && joined === "JOINED" ? (
        <div>
          <Controls />
          {/* //For rendering all the participants in the meeting */}
          {[...participants.keys()].map((participantId) => (
            <ParticipantView
              participantId={participantId}
              key={participantId}
            />
          ))}
        </div>
      ) : joined && joined == "JOINING" ? (
        <p>Joining the meeting...</p>
      ) : (
        <button onClick={joinMeeting}>Join</button>
      )}
    </div>
  );
}

function TestVideocall() {
    const [customAudioStream, setCustomAudioStream] = useState(null);
    const [customVideoStream, setCustomVideoStream] = useState(null)
    const [meetingId, setMeetingId] = useState(null);

    //Getting the meeting id by calling the api we just wrote
    const getMeetingAndToken = async (id) => {
    const meetingId =
        id == null ? await createMeeting({ token: authToken }) : id;
        setMeetingId(meetingId);
    };

  //This will set Meeting Id to null when meeting is left or ended
  const onMeetingLeave = () => {
    setMeetingId(null);
  };

  return authToken && meetingId ? (
      <MeetingProvider
          config={{ 
            meetingId, 
            micEnabled: true,
            webcamEnabled: true,
            name: "Jomar",


            customCameraVideoTrack: customVideoStream,
            //customAudioStream has to be the Audio Stream of the user's selected Microphone device as created in Step-5.
            customMicrophoneAudioTrack: customAudioStream
        
        }}
          token={authToken}>

          <MeetingView meetingId={meetingId} onMeetingLeave={onMeetingLeave} />
      </MeetingProvider>
  ) : (
    <JoinScreen getMeetingAndToken={getMeetingAndToken} />
  );
}

export default TestVideocall;